import Vue from 'vue';
import YmapPlugin from 'vue-yandex-maps';

Vue.use(YmapPlugin, {
    apiKey: '',
    lang: 'ru_RU',
    coordorder: 'longlat',
    enterprise: false,
    version: '2.1'
});